const storageKeyAuth: string = 'Retorik.Kiosk.AuthProvider.State';
const storageKeyConfiguration: string = 'Retorik.Kiosk.Settings';
const storageKeyChatbot: string = 'Retorik.Kiosk.Chatbot';
const storageKeyAgent: string = 'Retorik.Kiosk.CurrentAgent';
const storageKeyFontSize: string = 'Retorik.Kiosk.FontSize';
const storageKeyVeille: string = 'Retorik.Kiosk.Veille';
const storageKeyViews: string = 'Retorik.Kiosk.Views';
const storageKeyVoice: string = "Retorik.Kiosk.Voice";
const storageKeyDefaultMode: string = "Retorik.Kiosk.DefaultMode";
const storageKeyPrinter: string = "Retorik.Kiosk.Printer";

export {
  storageKeyAuth,
  storageKeyConfiguration,
  storageKeyChatbot,
  storageKeyAgent,
  storageKeyFontSize,
  storageKeyVeille,
  storageKeyViews,
  storageKeyVoice,
  storageKeyDefaultMode,
  storageKeyPrinter
};
